export default {
  GET_INFO_BY_INN_SUCCESS(state, { payload, type }) {
    type === 'organisation' ? (state.response.organisationName = payload) : (state.response.personalName = payload)
  },
  GET_INFO_BY_INN_ERROR(state, error) {
    state.errors.getNameByInn = error
  },
  SET_LOADING(state, { payload, type }) {
    type === 'organisation' ? (state.loading.getOrganisationName = payload) : (state.loading.getPersonalName = payload)
  },
  SETUP_EDITABLE_FIELD(state, { payload, type }) {
    type === 'organisation'
      ? (state.flags.isEditOrganisationName = payload)
      : (state.flags.isEditPersonalName = payload)
  },
  CLEAR_NAME(state, type) {
    type === 'organisation' ? (state.response.organisationName = '') : (state.response.personalName = '')
  }
}
